import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * Body of an import: `multipart/form-data` with `file`, `name` and, when not empty, `description`.
 * `preparationId` selects the route (the document joins that preparation) and never goes in the body.
 */
class ImportDocument {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly file: File,
		public readonly name: string,
		public readonly description: string | null,
		public readonly preparationId: number | null,
	) {
		Object.freeze(this);
	}

	toFormData(): FormData {
		const formData = new FormData();
		formData.append('file', this.file);
		formData.append('name', this.name);

		if (this.description !== null && this.description !== '') {
			formData.append('description', this.description);
		}

		return formData;
	}
}

export default ImportDocument;
